import React from 'react';
import clsx from 'clsx';

export default function Checkbox({
    value,
    label,
    onChange,
    disabled,
    name,
}: {
    value: boolean | undefined;
    label?: string | undefined;
    onChange?: (event: React.ChangeEvent<HTMLInputElement>) => void;
    disabled: boolean;
    name?: string | undefined;
}) {
    return (
        <div className="flex items-center justify-between w-full gap-3">
            {label && <div className="text-sm text-foreground">{label}</div>}
            <input
                type="checkbox"
                name={name}
                disabled={disabled}
                checked={value}
                onChange={(e) => {
                    if (onChange) onChange(e);
                }}
                style={({ accentColor: '#EA580C' } as unknown) as React.CSSProperties}
                className={clsx(
                    'w-4 h-4 rounded border-border',
                    disabled ? 'cursor-not-allowed' : 'cursor-pointer'
                )}
            />
        </div>
    );
}
